import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, t as toPathString, c as serializeDataIfNeeded, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ReviewsApi - axios parameter creator
 * @export
 */
const ReviewsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Deletes several reviews at once (soft delete, as a single delete); the product ratings are recomputed once. (Auth roles: Catalog,CMS)
         * @param {ReviewBulkRequest} [ReviewBulkRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteReviews: async (ReviewBulkRequest, options = {}) => {
            const localVarPath = `/v1/Reviews/BulkDeleteReviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewBulkRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Sets the status of several reviews at once. A customer review that becomes accepted gets what a single approval gives (the e-mail and the loyalty points); the product ratings are recomputed once. Returns how many changed. (Auth roles: Catalog)
         * @param {ReviewBulkStatusRequest} [ReviewBulkStatusRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSetReviewStatus: async (ReviewBulkStatusRequest, options = {}) => {
            const localVarPath = `/v1/Reviews/BulkSetReviewStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewBulkStatusRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [to_ent]
         * @param {number} [to_id]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerReview: async (to_ent, to_id, id, options = {}) => {
            const localVarPath = `/v1/Reviews/DeleteCustomerReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (to_ent !== undefined) {
                localVarQueryParameter['to_ent'] = to_ent;
            }
            if (to_id !== undefined) {
                localVarQueryParameter['to_id'] = to_id;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Removes a photo from a review (moderation). (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReviewPhoto: async (id, options = {}) => {
            const localVarPath = `/v1/Reviews/DeleteReviewPhoto`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {DuplicateContributorProductReviewToken} [DuplicateContributorProductReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateContributorProductReview: async (DuplicateContributorProductReviewToken, options = {}) => {
            const localVarPath = `/v1/Reviews/DuplicateContributorProductReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(DuplicateContributorProductReviewToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary The editorial reviews grid: contributors\' reviews of every kind of item, with their category. (Auth roles: Catalog)
         * @param {ReviewGetAllRequest} [ReviewGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContributorReview: async (ReviewGetAllRequest, options = {}) => {
            const localVarPath = `/v1/Reviews/GetAllContributorReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewGetAllRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary The moderation grid: customers\' reviews of every kind of item, each with what it is about (type, name, code, link, thumbnail), its author, photos and open reports. (Auth roles: Catalog)
         * @param {ReviewGetAllRequest} [ReviewGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomerReview: async (ReviewGetAllRequest, options = {}) => {
            const localVarPath = `/v1/Reviews/GetAllCustomerReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewGetAllRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {boolean} [editable]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerId: async (id, page, psize, editable, options = {}) => {
            const localVarPath = `/v1/Reviews/GetByCustomerId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            if (editable !== undefined) {
                localVarQueryParameter['editable'] = editable;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [toEntity]
         * @param {number} [toId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReview: async (toEntity, toId, options = {}) => {
            const localVarPath = `/v1/Reviews/GetCustomerReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (toEntity !== undefined) {
                localVarQueryParameter['toEntity'] = toEntity;
            }
            if (toId !== undefined) {
                localVarQueryParameter['toId'] = toId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary A page of the signed-in customer\'s own reviews of toEntity, newest first, each with its product; `total_count` counts them all. (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [toEntity] The reviewed entity type.
         * @param {number} [pageIndex] The page index (default is 1).
         * @param {number} [pageSize] The number of reviews per page (default is 10, at most BizWeb.NC.API.Controllers.ReviewsController.MaxReviewsPageSize).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReviewsByEntity: async (toEntity, pageIndex, pageSize, options = {}) => {
            const localVarPath = `/v1/Reviews/GetCustomerReviewsByEntity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (toEntity !== undefined) {
                localVarQueryParameter['toEntity'] = toEntity;
            }
            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Customer reviews of any item waiting for moderation (the admin menu\'s badge). (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingReviewsCount: async (options = {}) => {
            const localVarPath = `/v1/Reviews/GetPendingReviewsCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary The details panel of one review: what it is about (any kind of item; category and publisher for a product), and who wrote it (a customer with their orders and reviews, or a contributor). (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewInfo: async (id, options = {}) => {
            const localVarPath = `/v1/Reviews/GetReviewInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary The reports on a review, newest first, with who sent them. (Auth roles: Catalog)
         * @param {number} [reviewId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewReports: async (reviewId, options = {}) => {
            const localVarPath = `/v1/Reviews/GetReviewReports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (reviewId !== undefined) {
                localVarQueryParameter['reviewId'] = reviewId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewStatus: async (options = {}) => {
            const localVarPath = `/v1/Reviews/GetReviewStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewStatuses: async (options = {}) => {
            const localVarPath = `/v1/Reviews/GetReviewStatuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReviewTokenRequest} [ReviewTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviews: async (ReviewTokenRequest, options = {}) => {
            const localVarPath = `/v1/Reviews/GetReviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewTokenRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieves a paginated and filtered list of reviews for a specified entity,  including optional sorting, rating range filtering, and the current user\'s own review if available.
         * @param {BizwebEntityType} [toEntity] The target entity type (e.g., Product, Vendor, etc.) to which the reviews belong.
         * @param {number} [toId] The unique identifier of the target entity.
         * @param {number} [pageIndex] The page index for pagination (default is 1).
         * @param {number} [pageSize] The number of reviews per page (default is 10, at most BizWeb.NC.API.Controllers.ReviewsController.MaxReviewsPageSize).
         * @param {string} [sort] The sorting option for reviews. Supported values include: &lt;list type&#x3D;\&quot;bullet\&quot;&gt;&lt;item&gt;&lt;description&gt;&#x60;rating_desc&#x60; – Sort by highest rating first.&lt;/description&gt;&lt;/item&gt;&lt;item&gt;&lt;description&gt;&#x60;rating_asc&#x60; – Sort by lowest rating first.&lt;/description&gt;&lt;/item&gt;&lt;item&gt;&lt;description&gt;&#x60;most_helpful&#x60; – Sort by the most \&quot;helpful\&quot; votes first.&lt;/description&gt;&lt;/item&gt;&lt;item&gt;&lt;description&gt;&#x60;newest_first&#x60; – Featured reviews first, then the newest (default).&lt;/description&gt;&lt;/item&gt;&lt;/list&gt;
         * @param {number} [rateFrom] Minimum rating (inclusive) to filter by. If null, no lower bound is applied.
         * @param {number} [rateTo] Maximum rating (inclusive) to filter by. If null, no upper bound is applied.
         * @param {boolean} [withPhotos] When true, only reviews with at least one photo.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewsFiltering: async (toEntity, toId, pageIndex, pageSize, sort, rateFrom, rateTo, withPhotos, options = {}) => {
            const localVarPath = `/v1/Reviews/GetReviewsFiltering`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (toEntity !== undefined) {
                localVarQueryParameter['toEntity'] = toEntity;
            }
            if (toId !== undefined) {
                localVarQueryParameter['toId'] = toId;
            }
            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (rateFrom !== undefined) {
                localVarQueryParameter['rateFrom'] = rateFrom;
            }
            if (rateTo !== undefined) {
                localVarQueryParameter['rateTo'] = rateTo;
            }
            if (withPhotos !== undefined) {
                localVarQueryParameter['withPhotos'] = withPhotos;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieves review statistics (such as total reviews, average rating, and rating distribution)  for a specified entity and identifier.
         * @param {BizwebEntityType} [toEntity] The target entity type (e.g., Product, Vendor, etc.) to which the reviews belong.
         * @param {number} [toId] The unique identifier of the target entity.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewsStatistics: async (toEntity, toId, options = {}) => {
            const localVarPath = `/v1/Reviews/GetReviewsStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (toEntity !== undefined) {
                localVarQueryParameter['toEntity'] = toEntity;
            }
            if (toId !== undefined) {
                localVarQueryParameter['toId'] = toId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertContributorProductReview: async (ReviewToken, options = {}) => {
            const localVarPath = `/v1/Reviews/InsertContributorProductReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCustomerProductReview: async (ReviewToken, options = {}) => {
            const localVarPath = `/v1/Reviews/InsertCustomerProductReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCustomerReview: async (ReviewToken, options = {}) => {
            const localVarPath = `/v1/Reviews/InsertCustomerReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reCalculateProductReviews: async (options = {}) => {
            const localVarPath = `/v1/Reviews/ReCalculateProductReviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog,CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/Reviews/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reports a published review as inappropriate. Once per customer and review (a repeat is a no-op); not one\'s own. The admin sees the open reports in the reviews grid. (Auth roles: FrontEndUsers)
         * @param {ReviewReportRequest} [ReviewReportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportReview: async (ReviewReportRequest, options = {}) => {
            const localVarPath = `/v1/Reviews/ReportReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewReportRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Marks a review\'s open reports as handled (after acting on the review, or deciding it is fine). (Auth roles: Catalog)
         * @param {number} [reviewId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveReviewReports: async (reviewId, options = {}) => {
            const localVarPath = `/v1/Reviews/ResolveReviewReports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (reviewId !== undefined) {
                localVarQueryParameter['reviewId'] = reviewId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Marks an accepted review helpful for the signed-in customer, or takes the vote back. Not on one\'s own review. (Auth roles: FrontEndUsers)
         * @param {number} [reviewId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleHelpfulVote: async (reviewId, options = {}) => {
            const localVarPath = `/v1/Reviews/ToggleHelpfulVote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (reviewId !== undefined) {
                localVarQueryParameter['reviewId'] = reviewId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (ReviewToken, options = {}) => {
            const localVarPath = `/v1/Reviews/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContributorProductReview: async (ReviewToken, options = {}) => {
            const localVarPath = `/v1/Reviews/UpdateContributorProductReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerProductReview: async (ReviewToken, options = {}) => {
            const localVarPath = `/v1/Reviews/UpdateCustomerProductReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerReview: async (ReviewToken, options = {}) => {
            const localVarPath = `/v1/Reviews/UpdateCustomerReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Uploads one photo for a review the customer is writing: validated, stripped of its metadata, shrunk and kept unclaimed until the review is saved with it (photos[] = {id, token}). Unused uploads are swept after two days. (Auth roles: FrontEndUsers)
         * @param {File} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPhoto: async (file, options = {}) => {
            const localVarPath = `/v1/Reviews/UploadPhoto`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ReviewsApi - functional programming interface
 * @export
 */
const ReviewsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReviewsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Deletes several reviews at once (soft delete, as a single delete); the product ratings are recomputed once. (Auth roles: Catalog,CMS)
         * @param {ReviewBulkRequest} [ReviewBulkRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteReviews(ReviewBulkRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteReviews(ReviewBulkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.bulkDeleteReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Sets the status of several reviews at once. A customer review that becomes accepted gets what a single approval gives (the e-mail and the loyalty points); the product ratings are recomputed once. Returns how many changed. (Auth roles: Catalog)
         * @param {ReviewBulkStatusRequest} [ReviewBulkStatusRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkSetReviewStatus(ReviewBulkStatusRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkSetReviewStatus(ReviewBulkStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.bulkSetReviewStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [to_ent]
         * @param {number} [to_id]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomerReview(to_ent, to_id, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomerReview(to_ent, to_id, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.deleteCustomerReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Removes a photo from a review (moderation). (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReviewPhoto(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReviewPhoto(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.deleteReviewPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {DuplicateContributorProductReviewToken} [DuplicateContributorProductReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateContributorProductReview(DuplicateContributorProductReviewToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateContributorProductReview(DuplicateContributorProductReviewToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.duplicateContributorProductReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary The editorial reviews grid: contributors\' reviews of every kind of item, with their category. (Auth roles: Catalog)
         * @param {ReviewGetAllRequest} [ReviewGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllContributorReview(ReviewGetAllRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllContributorReview(ReviewGetAllRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getAllContributorReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary The moderation grid: customers\' reviews of every kind of item, each with what it is about (type, name, code, link, thumbnail), its author, photos and open reports. (Auth roles: Catalog)
         * @param {ReviewGetAllRequest} [ReviewGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCustomerReview(ReviewGetAllRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCustomerReview(ReviewGetAllRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getAllCustomerReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {boolean} [editable]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCustomerId(id, page, psize, editable, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCustomerId(id, page, psize, editable, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getByCustomerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [toEntity]
         * @param {number} [toId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerReview(toEntity, toId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerReview(toEntity, toId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getCustomerReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary A page of the signed-in customer\'s own reviews of toEntity, newest first, each with its product; `total_count` counts them all. (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [toEntity] The reviewed entity type.
         * @param {number} [pageIndex] The page index (default is 1).
         * @param {number} [pageSize] The number of reviews per page (default is 10, at most BizWeb.NC.API.Controllers.ReviewsController.MaxReviewsPageSize).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerReviewsByEntity(toEntity, pageIndex, pageSize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerReviewsByEntity(toEntity, pageIndex, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getCustomerReviewsByEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Customer reviews of any item waiting for moderation (the admin menu\'s badge). (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingReviewsCount(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingReviewsCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getPendingReviewsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary The details panel of one review: what it is about (any kind of item; category and publisher for a product), and who wrote it (a customer with their orders and reviews, or a contributor). (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviewInfo(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviewInfo(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getReviewInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary The reports on a review, newest first, with who sent them. (Auth roles: Catalog)
         * @param {number} [reviewId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviewReports(reviewId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviewReports(reviewId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getReviewReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviewStatus(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviewStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getReviewStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviewStatuses(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviewStatuses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getReviewStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ReviewTokenRequest} [ReviewTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviews(ReviewTokenRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviews(ReviewTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieves a paginated and filtered list of reviews for a specified entity,  including optional sorting, rating range filtering, and the current user\'s own review if available.
         * @param {BizwebEntityType} [toEntity] The target entity type (e.g., Product, Vendor, etc.) to which the reviews belong.
         * @param {number} [toId] The unique identifier of the target entity.
         * @param {number} [pageIndex] The page index for pagination (default is 1).
         * @param {number} [pageSize] The number of reviews per page (default is 10, at most BizWeb.NC.API.Controllers.ReviewsController.MaxReviewsPageSize).
         * @param {string} [sort] The sorting option for reviews. Supported values include: &lt;list type&#x3D;\&quot;bullet\&quot;&gt;&lt;item&gt;&lt;description&gt;&#x60;rating_desc&#x60; – Sort by highest rating first.&lt;/description&gt;&lt;/item&gt;&lt;item&gt;&lt;description&gt;&#x60;rating_asc&#x60; – Sort by lowest rating first.&lt;/description&gt;&lt;/item&gt;&lt;item&gt;&lt;description&gt;&#x60;most_helpful&#x60; – Sort by the most \&quot;helpful\&quot; votes first.&lt;/description&gt;&lt;/item&gt;&lt;item&gt;&lt;description&gt;&#x60;newest_first&#x60; – Featured reviews first, then the newest (default).&lt;/description&gt;&lt;/item&gt;&lt;/list&gt;
         * @param {number} [rateFrom] Minimum rating (inclusive) to filter by. If null, no lower bound is applied.
         * @param {number} [rateTo] Maximum rating (inclusive) to filter by. If null, no upper bound is applied.
         * @param {boolean} [withPhotos] When true, only reviews with at least one photo.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviewsFiltering(toEntity, toId, pageIndex, pageSize, sort, rateFrom, rateTo, withPhotos, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviewsFiltering(toEntity, toId, pageIndex, pageSize, sort, rateFrom, rateTo, withPhotos, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getReviewsFiltering']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieves review statistics (such as total reviews, average rating, and rating distribution)  for a specified entity and identifier.
         * @param {BizwebEntityType} [toEntity] The target entity type (e.g., Product, Vendor, etc.) to which the reviews belong.
         * @param {number} [toId] The unique identifier of the target entity.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviewsStatistics(toEntity, toId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviewsStatistics(toEntity, toId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getReviewsStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertContributorProductReview(ReviewToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertContributorProductReview(ReviewToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.insertContributorProductReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertCustomerProductReview(ReviewToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertCustomerProductReview(ReviewToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.insertCustomerProductReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertCustomerReview(ReviewToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertCustomerReview(ReviewToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.insertCustomerReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reCalculateProductReviews(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reCalculateProductReviews(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.reCalculateProductReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog,CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Reports a published review as inappropriate. Once per customer and review (a repeat is a no-op); not one\'s own. The admin sees the open reports in the reviews grid. (Auth roles: FrontEndUsers)
         * @param {ReviewReportRequest} [ReviewReportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportReview(ReviewReportRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportReview(ReviewReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.reportReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Marks a review\'s open reports as handled (after acting on the review, or deciding it is fine). (Auth roles: Catalog)
         * @param {number} [reviewId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveReviewReports(reviewId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveReviewReports(reviewId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.resolveReviewReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Marks an accepted review helpful for the signed-in customer, or takes the vote back. Not on one\'s own review. (Auth roles: FrontEndUsers)
         * @param {number} [reviewId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleHelpfulVote(reviewId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleHelpfulVote(reviewId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.toggleHelpfulVote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(ReviewToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(ReviewToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContributorProductReview(ReviewToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContributorProductReview(ReviewToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.updateContributorProductReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerProductReview(ReviewToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerProductReview(ReviewToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.updateCustomerProductReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerReview(ReviewToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerReview(ReviewToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.updateCustomerReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Uploads one photo for a review the customer is writing: validated, stripped of its metadata, shrunk and kept unclaimed until the review is saved with it (photos[] = {id, token}). Unused uploads are swept after two days. (Auth roles: FrontEndUsers)
         * @param {File} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPhoto(file, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPhoto(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.uploadPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ReviewsApi - factory interface
 * @export
 */
const ReviewsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReviewsApiFp(configuration);
    return {
        /**
         *
         * @summary Deletes several reviews at once (soft delete, as a single delete); the product ratings are recomputed once. (Auth roles: Catalog,CMS)
         * @param {ReviewBulkRequest} [ReviewBulkRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteReviews(ReviewBulkRequest, options) {
            return localVarFp.bulkDeleteReviews(ReviewBulkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sets the status of several reviews at once. A customer review that becomes accepted gets what a single approval gives (the e-mail and the loyalty points); the product ratings are recomputed once. Returns how many changed. (Auth roles: Catalog)
         * @param {ReviewBulkStatusRequest} [ReviewBulkStatusRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSetReviewStatus(ReviewBulkStatusRequest, options) {
            return localVarFp.bulkSetReviewStatus(ReviewBulkStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [to_ent]
         * @param {number} [to_id]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerReview(to_ent, to_id, id, options) {
            return localVarFp.deleteCustomerReview(to_ent, to_id, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Removes a photo from a review (moderation). (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReviewPhoto(id, options) {
            return localVarFp.deleteReviewPhoto(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {DuplicateContributorProductReviewToken} [DuplicateContributorProductReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateContributorProductReview(DuplicateContributorProductReviewToken, options) {
            return localVarFp.duplicateContributorProductReview(DuplicateContributorProductReviewToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary The editorial reviews grid: contributors\' reviews of every kind of item, with their category. (Auth roles: Catalog)
         * @param {ReviewGetAllRequest} [ReviewGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContributorReview(ReviewGetAllRequest, options) {
            return localVarFp.getAllContributorReview(ReviewGetAllRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary The moderation grid: customers\' reviews of every kind of item, each with what it is about (type, name, code, link, thumbnail), its author, photos and open reports. (Auth roles: Catalog)
         * @param {ReviewGetAllRequest} [ReviewGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomerReview(ReviewGetAllRequest, options) {
            return localVarFp.getAllCustomerReview(ReviewGetAllRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {boolean} [editable]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerId(id, page, psize, editable, options) {
            return localVarFp.getByCustomerId(id, page, psize, editable, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [toEntity]
         * @param {number} [toId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReview(toEntity, toId, options) {
            return localVarFp.getCustomerReview(toEntity, toId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary A page of the signed-in customer\'s own reviews of toEntity, newest first, each with its product; `total_count` counts them all. (Auth roles: FrontEndUsers)
         * @param {BizwebEntityType} [toEntity] The reviewed entity type.
         * @param {number} [pageIndex] The page index (default is 1).
         * @param {number} [pageSize] The number of reviews per page (default is 10, at most BizWeb.NC.API.Controllers.ReviewsController.MaxReviewsPageSize).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReviewsByEntity(toEntity, pageIndex, pageSize, options) {
            return localVarFp.getCustomerReviewsByEntity(toEntity, pageIndex, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Customer reviews of any item waiting for moderation (the admin menu\'s badge). (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingReviewsCount(options) {
            return localVarFp.getPendingReviewsCount(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary The details panel of one review: what it is about (any kind of item; category and publisher for a product), and who wrote it (a customer with their orders and reviews, or a contributor). (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewInfo(id, options) {
            return localVarFp.getReviewInfo(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary The reports on a review, newest first, with who sent them. (Auth roles: Catalog)
         * @param {number} [reviewId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewReports(reviewId, options) {
            return localVarFp.getReviewReports(reviewId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewStatus(options) {
            return localVarFp.getReviewStatus(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewStatuses(options) {
            return localVarFp.getReviewStatuses(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReviewTokenRequest} [ReviewTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviews(ReviewTokenRequest, options) {
            return localVarFp.getReviews(ReviewTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves a paginated and filtered list of reviews for a specified entity,  including optional sorting, rating range filtering, and the current user\'s own review if available.
         * @param {BizwebEntityType} [toEntity] The target entity type (e.g., Product, Vendor, etc.) to which the reviews belong.
         * @param {number} [toId] The unique identifier of the target entity.
         * @param {number} [pageIndex] The page index for pagination (default is 1).
         * @param {number} [pageSize] The number of reviews per page (default is 10, at most BizWeb.NC.API.Controllers.ReviewsController.MaxReviewsPageSize).
         * @param {string} [sort] The sorting option for reviews. Supported values include: &lt;list type&#x3D;\&quot;bullet\&quot;&gt;&lt;item&gt;&lt;description&gt;&#x60;rating_desc&#x60; – Sort by highest rating first.&lt;/description&gt;&lt;/item&gt;&lt;item&gt;&lt;description&gt;&#x60;rating_asc&#x60; – Sort by lowest rating first.&lt;/description&gt;&lt;/item&gt;&lt;item&gt;&lt;description&gt;&#x60;most_helpful&#x60; – Sort by the most \&quot;helpful\&quot; votes first.&lt;/description&gt;&lt;/item&gt;&lt;item&gt;&lt;description&gt;&#x60;newest_first&#x60; – Featured reviews first, then the newest (default).&lt;/description&gt;&lt;/item&gt;&lt;/list&gt;
         * @param {number} [rateFrom] Minimum rating (inclusive) to filter by. If null, no lower bound is applied.
         * @param {number} [rateTo] Maximum rating (inclusive) to filter by. If null, no upper bound is applied.
         * @param {boolean} [withPhotos] When true, only reviews with at least one photo.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewsFiltering(toEntity, toId, pageIndex, pageSize, sort, rateFrom, rateTo, withPhotos, options) {
            return localVarFp.getReviewsFiltering(toEntity, toId, pageIndex, pageSize, sort, rateFrom, rateTo, withPhotos, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves review statistics (such as total reviews, average rating, and rating distribution)  for a specified entity and identifier.
         * @param {BizwebEntityType} [toEntity] The target entity type (e.g., Product, Vendor, etc.) to which the reviews belong.
         * @param {number} [toId] The unique identifier of the target entity.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewsStatistics(toEntity, toId, options) {
            return localVarFp.getReviewsStatistics(toEntity, toId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertContributorProductReview(ReviewToken, options) {
            return localVarFp.insertContributorProductReview(ReviewToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCustomerProductReview(ReviewToken, options) {
            return localVarFp.insertCustomerProductReview(ReviewToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCustomerReview(ReviewToken, options) {
            return localVarFp.insertCustomerReview(ReviewToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reCalculateProductReviews(options) {
            return localVarFp.reCalculateProductReviews(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog,CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reports a published review as inappropriate. Once per customer and review (a repeat is a no-op); not one\'s own. The admin sees the open reports in the reviews grid. (Auth roles: FrontEndUsers)
         * @param {ReviewReportRequest} [ReviewReportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportReview(ReviewReportRequest, options) {
            return localVarFp.reportReview(ReviewReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Marks a review\'s open reports as handled (after acting on the review, or deciding it is fine). (Auth roles: Catalog)
         * @param {number} [reviewId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveReviewReports(reviewId, options) {
            return localVarFp.resolveReviewReports(reviewId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Marks an accepted review helpful for the signed-in customer, or takes the vote back. Not on one\'s own review. (Auth roles: FrontEndUsers)
         * @param {number} [reviewId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleHelpfulVote(reviewId, options) {
            return localVarFp.toggleHelpfulVote(reviewId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(ReviewToken, options) {
            return localVarFp.update(ReviewToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContributorProductReview(ReviewToken, options) {
            return localVarFp.updateContributorProductReview(ReviewToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerProductReview(ReviewToken, options) {
            return localVarFp.updateCustomerProductReview(ReviewToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerReview(ReviewToken, options) {
            return localVarFp.updateCustomerReview(ReviewToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Uploads one photo for a review the customer is writing: validated, stripped of its metadata, shrunk and kept unclaimed until the review is saved with it (photos[] = {id, token}). Unused uploads are swept after two days. (Auth roles: FrontEndUsers)
         * @param {File} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPhoto(file, options) {
            return localVarFp.uploadPhoto(file, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReviewsApi - object-oriented interface
 * @export
 * @class ReviewsApi
 * @extends {BaseAPI}
 */
class ReviewsApi extends BaseAPI {
    /**
     *
     * @summary Deletes several reviews at once (soft delete, as a single delete); the product ratings are recomputed once. (Auth roles: Catalog,CMS)
     * @param {ReviewBulkRequest} [ReviewBulkRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    bulkDeleteReviews(ReviewBulkRequest, options) {
        return ReviewsApiFp(this.configuration).bulkDeleteReviews(ReviewBulkRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sets the status of several reviews at once. A customer review that becomes accepted gets what a single approval gives (the e-mail and the loyalty points); the product ratings are recomputed once. Returns how many changed. (Auth roles: Catalog)
     * @param {ReviewBulkStatusRequest} [ReviewBulkStatusRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    bulkSetReviewStatus(ReviewBulkStatusRequest, options) {
        return ReviewsApiFp(this.configuration).bulkSetReviewStatus(ReviewBulkStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {BizwebEntityType} [to_ent]
     * @param {number} [to_id]
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    deleteCustomerReview(to_ent, to_id, id, options) {
        return ReviewsApiFp(this.configuration).deleteCustomerReview(to_ent, to_id, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Removes a photo from a review (moderation). (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    deleteReviewPhoto(id, options) {
        return ReviewsApiFp(this.configuration).deleteReviewPhoto(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {DuplicateContributorProductReviewToken} [DuplicateContributorProductReviewToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    duplicateContributorProductReview(DuplicateContributorProductReviewToken, options) {
        return ReviewsApiFp(this.configuration).duplicateContributorProductReview(DuplicateContributorProductReviewToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary The editorial reviews grid: contributors\' reviews of every kind of item, with their category. (Auth roles: Catalog)
     * @param {ReviewGetAllRequest} [ReviewGetAllRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    getAllContributorReview(ReviewGetAllRequest, options) {
        return ReviewsApiFp(this.configuration).getAllContributorReview(ReviewGetAllRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary The moderation grid: customers\' reviews of every kind of item, each with what it is about (type, name, code, link, thumbnail), its author, photos and open reports. (Auth roles: Catalog)
     * @param {ReviewGetAllRequest} [ReviewGetAllRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    getAllCustomerReview(ReviewGetAllRequest, options) {
        return ReviewsApiFp(this.configuration).getAllCustomerReview(ReviewGetAllRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {boolean} [editable]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    getByCustomerId(id, page, psize, editable, options) {
        return ReviewsApiFp(this.configuration).getByCustomerId(id, page, psize, editable, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {BizwebEntityType} [toEntity]
     * @param {number} [toId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    getCustomerReview(toEntity, toId, options) {
        return ReviewsApiFp(this.configuration).getCustomerReview(toEntity, toId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary A page of the signed-in customer\'s own reviews of toEntity, newest first, each with its product; `total_count` counts them all. (Auth roles: FrontEndUsers)
     * @param {BizwebEntityType} [toEntity] The reviewed entity type.
     * @param {number} [pageIndex] The page index (default is 1).
     * @param {number} [pageSize] The number of reviews per page (default is 10, at most BizWeb.NC.API.Controllers.ReviewsController.MaxReviewsPageSize).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    getCustomerReviewsByEntity(toEntity, pageIndex, pageSize, options) {
        return ReviewsApiFp(this.configuration).getCustomerReviewsByEntity(toEntity, pageIndex, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Customer reviews of any item waiting for moderation (the admin menu\'s badge). (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    getPendingReviewsCount(options) {
        return ReviewsApiFp(this.configuration).getPendingReviewsCount(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary The details panel of one review: what it is about (any kind of item; category and publisher for a product), and who wrote it (a customer with their orders and reviews, or a contributor). (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    getReviewInfo(id, options) {
        return ReviewsApiFp(this.configuration).getReviewInfo(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary The reports on a review, newest first, with who sent them. (Auth roles: Catalog)
     * @param {number} [reviewId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    getReviewReports(reviewId, options) {
        return ReviewsApiFp(this.configuration).getReviewReports(reviewId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    getReviewStatus(options) {
        return ReviewsApiFp(this.configuration).getReviewStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    getReviewStatuses(options) {
        return ReviewsApiFp(this.configuration).getReviewStatuses(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReviewTokenRequest} [ReviewTokenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    getReviews(ReviewTokenRequest, options) {
        return ReviewsApiFp(this.configuration).getReviews(ReviewTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves a paginated and filtered list of reviews for a specified entity,  including optional sorting, rating range filtering, and the current user\'s own review if available.
     * @param {BizwebEntityType} [toEntity] The target entity type (e.g., Product, Vendor, etc.) to which the reviews belong.
     * @param {number} [toId] The unique identifier of the target entity.
     * @param {number} [pageIndex] The page index for pagination (default is 1).
     * @param {number} [pageSize] The number of reviews per page (default is 10, at most BizWeb.NC.API.Controllers.ReviewsController.MaxReviewsPageSize).
     * @param {string} [sort] The sorting option for reviews. Supported values include: &lt;list type&#x3D;\&quot;bullet\&quot;&gt;&lt;item&gt;&lt;description&gt;&#x60;rating_desc&#x60; – Sort by highest rating first.&lt;/description&gt;&lt;/item&gt;&lt;item&gt;&lt;description&gt;&#x60;rating_asc&#x60; – Sort by lowest rating first.&lt;/description&gt;&lt;/item&gt;&lt;item&gt;&lt;description&gt;&#x60;most_helpful&#x60; – Sort by the most \&quot;helpful\&quot; votes first.&lt;/description&gt;&lt;/item&gt;&lt;item&gt;&lt;description&gt;&#x60;newest_first&#x60; – Featured reviews first, then the newest (default).&lt;/description&gt;&lt;/item&gt;&lt;/list&gt;
     * @param {number} [rateFrom] Minimum rating (inclusive) to filter by. If null, no lower bound is applied.
     * @param {number} [rateTo] Maximum rating (inclusive) to filter by. If null, no upper bound is applied.
     * @param {boolean} [withPhotos] When true, only reviews with at least one photo.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    getReviewsFiltering(toEntity, toId, pageIndex, pageSize, sort, rateFrom, rateTo, withPhotos, options) {
        return ReviewsApiFp(this.configuration).getReviewsFiltering(toEntity, toId, pageIndex, pageSize, sort, rateFrom, rateTo, withPhotos, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves review statistics (such as total reviews, average rating, and rating distribution)  for a specified entity and identifier.
     * @param {BizwebEntityType} [toEntity] The target entity type (e.g., Product, Vendor, etc.) to which the reviews belong.
     * @param {number} [toId] The unique identifier of the target entity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    getReviewsStatistics(toEntity, toId, options) {
        return ReviewsApiFp(this.configuration).getReviewsStatistics(toEntity, toId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {ReviewToken} [ReviewToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    insertContributorProductReview(ReviewToken, options) {
        return ReviewsApiFp(this.configuration).insertContributorProductReview(ReviewToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {ReviewToken} [ReviewToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    insertCustomerProductReview(ReviewToken, options) {
        return ReviewsApiFp(this.configuration).insertCustomerProductReview(ReviewToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {ReviewToken} [ReviewToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    insertCustomerReview(ReviewToken, options) {
        return ReviewsApiFp(this.configuration).insertCustomerReview(ReviewToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    reCalculateProductReviews(options) {
        return ReviewsApiFp(this.configuration).reCalculateProductReviews(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog,CMS)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    remove(id, options) {
        return ReviewsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reports a published review as inappropriate. Once per customer and review (a repeat is a no-op); not one\'s own. The admin sees the open reports in the reviews grid. (Auth roles: FrontEndUsers)
     * @param {ReviewReportRequest} [ReviewReportRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    reportReview(ReviewReportRequest, options) {
        return ReviewsApiFp(this.configuration).reportReview(ReviewReportRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Marks a review\'s open reports as handled (after acting on the review, or deciding it is fine). (Auth roles: Catalog)
     * @param {number} [reviewId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    resolveReviewReports(reviewId, options) {
        return ReviewsApiFp(this.configuration).resolveReviewReports(reviewId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Marks an accepted review helpful for the signed-in customer, or takes the vote back. Not on one\'s own review. (Auth roles: FrontEndUsers)
     * @param {number} [reviewId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    toggleHelpfulVote(reviewId, options) {
        return ReviewsApiFp(this.configuration).toggleHelpfulVote(reviewId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {ReviewToken} [ReviewToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    update(ReviewToken, options) {
        return ReviewsApiFp(this.configuration).update(ReviewToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {ReviewToken} [ReviewToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    updateContributorProductReview(ReviewToken, options) {
        return ReviewsApiFp(this.configuration).updateContributorProductReview(ReviewToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {ReviewToken} [ReviewToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    updateCustomerProductReview(ReviewToken, options) {
        return ReviewsApiFp(this.configuration).updateCustomerProductReview(ReviewToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {ReviewToken} [ReviewToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    updateCustomerReview(ReviewToken, options) {
        return ReviewsApiFp(this.configuration).updateCustomerReview(ReviewToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Uploads one photo for a review the customer is writing: validated, stripped of its metadata, shrunk and kept unclaimed until the review is saved with it (photos[] = {id, token}). Unused uploads are swept after two days. (Auth roles: FrontEndUsers)
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    uploadPhoto(file, options) {
        return ReviewsApiFp(this.configuration).uploadPhoto(file, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ReviewsApi, ReviewsApiAxiosParamCreator, ReviewsApiFactory, ReviewsApiFp };
//# sourceMappingURL=reviews-api.js.map
